const { CarouselElement } = window.BAO.Carousel
const { useArrows } = window.BAO.Carousel.plugins

export class SplitHeroCarousel extends CarouselElement {
  static get requiredElements () {
    return ['slider', 'slide', 'previous', 'next']
  }

  get isMobile () {
    return window.matchMedia('(max-width: 767px)').matches
  }

  get isStacked () {
    return this.dataset.mobileStack === 'true' && this.isMobile
  }

  get options () {
    return {
      enabled: !this.isStacked,

      slides: {
        perView: 'auto',
      },
    }
  }

  get plugins () {
    return [
      useArrows({
        next: this.els.next?.element,
        previous: this.els.previous?.element,
      }),
    ]
  }
}

if (!customElements.get('split-hero-carousel')) {
  customElements.define('split-hero-carousel', SplitHeroCarousel)
}
